import { HtmlGraphicObject, createSvgAndSvgObjects, ColorConverter } from "../../../../web-graphics";

// color in webgl format
export class Label extends HtmlGraphicObject {
  constructor(settings) {
    super(settings);

    if (this.settings.isCentered === undefined) {
      this.settings.isCentered = true;
    }
    if (this.settings.isBold === undefined) {
      this.settings.isBold = false;
    }
    const colorParserResult = ColorConverter.convertWebglRgbaToHex(this.settings.color);
    this.settings.color = colorParserResult.success ? colorParserResult.value : "#000000";
    HtmlGraphicObject.setHtmlObject(
      this.settings,
      createSvgAndSvgObjects(
        "text",
        ["x", `${this.settings.htmlObject.absoluteLocation.x}px`],
        ["y", `${this.settings.htmlObject.absoluteLocation.y}px`],
        ["text-anchor", "start"],
        ["fill", this.settings.color],
        ["font-size", this.settings.fontSize],
        ["font-family", this.settings.fontFamily]
      )
    );
    this.settings.htmlObject.ref.innerHTML = this.settings.title;
    //this.htmlObject.textContent = text;

    // update x by text width
    Label.updateLabelLocation(this.settings);
  }

  static updateLabelLocation(settings) {
    const htmlObject = settings.htmlObject.ref;
    const bbox = htmlObject.getBBox();
    // calculate text position from left corner (0, 0)
    let y = settings.htmlObject.absoluteLocation.y;
    let x = settings.htmlObject.absoluteLocation.x;
    if (settings.isCentered) {
      x += settings.htmlObject.sizeInPixels.width / 2 - bbox.width / 2;
    }
    y += settings.htmlObject.sizeInPixels.height / 2 + bbox.height / 4;
    htmlObject.setAttribute("x", `${x}px`);
    htmlObject.setAttribute("y", `${y}px`);
  }

  getXFromReal(realX, realWidth) {
    let x = realX;
    if (this.settings.isCentered) {
      x -= (this.settings.htmlObject.sizeInPixels.width / 2 - realWidth / 2);
    }
    return x;
  }

  getYFromReal(realY, realHeight) {
    return realY - this.settings.htmlObject.sizeInPixels.height / 2 - realHeight / 4;
  }

  setIsBold(status) {
    this.settings.isBold = status;
    this.settings.htmlObject.ref.setAttribute("font-weight", this.settings.isBold ? "bold" : "normal");
  }

  addOnClickedFunction(action) {
    this.settings.htmlObject.ref.addEventListener("click", action);
  }

  setText(text) {
    this.settings.title = text;
    this.settings.htmlObject.ref.innerHTML = this.settings.title;
    Label.updateLabelLocation(this.settings);
  }

  createHtmlBorders() {
    super.createHtmlBorders();
    Label.updateLabelLocation(this.settings);
  }
}
